"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var localstyles = require("./CollapsedCartView.scss");
var icons = require("../../../styles/ccc-icons-cart.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var ReportingService_1 = require("../../../api/ReportingService");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var CollapsedCartView = /** @class */ (function (_super) {
    __extends(CollapsedCartView, _super);
    function CollapsedCartView(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleLinkHandler = _this.toggleLinkHandler.bind(_this);
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    CollapsedCartView.prototype.render = function () {
        var collpasedCartHeading = 'View my cart';
        var cartCoreCMSData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout');
        if (cartCoreCMSData && cartCoreCMSData.content && cartCoreCMSData.content.core
            && cartCoreCMSData.content.core.collpasedCartHeading) {
            collpasedCartHeading = cartCoreCMSData.content.core.collapedCartHeading;
        }
        return (React.createElement("div", null,
            React.createElement("span", null,
                React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartLg,
                        icons.cccIconCartFullcart, localstyles.cartIconStyles].join(' '), role: "img", "aria-label": 'Cart icon' })),
            React.createElement("div", { className: [localstyles.viewCartLink].join(' '), onClick: this.toggleLinkHandler, id: utils_1.default('Collapsed', 'Cart', 'View') },
                React.createElement(ui_components_1.Label, { testId: utils_1.default('View_Cart', 'Label'), data: { text: collpasedCartHeading }, options: {
                        className: localstyles.subSectionHeading,
                        tabIndex: 0,
                    } }),
                this.props.data.cartCollapsed &&
                    React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartLg,
                            icons.cccIconCartDown, localstyles.toggleArrowStyles].join(' '), role: "img", tabIndex: 0, "aria-label": 'Expand cart' }),
                !this.props.data.cartCollapsed &&
                    React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartLg,
                            icons.cccIconCartUp, localstyles.toggleArrowStyles].join(' '), role: "img", tabIndex: 0, "aria-label": 'Collapse cart' }))));
    };
    CollapsedCartView.prototype.toggleLinkHandler = function () {
        if (this.props.data && this.props.data.cartCollapsed) {
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            this.reportingService.fireLinkClickWithOutPageLoad('Expand cart', ReportingService_1.PageUrls.CARTVIEW_PAGE);
        }
        if (this.props.data && !this.props.data.cartCollapsed) {
            this.reportingService.fireLinkClickWithOutPageLoad('Collapse cart', ReportingService_1.PageUrls.CARTVIEW_PAGE);
        }
        if (this.props && this.props.events && this.props.events.toggleExpandCollapseCart) {
            this.props.events.toggleExpandCollapseCart();
        }
    };
    return CollapsedCartView;
}(React.Component));
exports.default = CollapsedCartView;
//# sourceMappingURL=CollapsedCartView.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/CollapsedCartView/CollapsedCartView.js
// module id = 2325
// module chunks = 8